import {
  ActionIcon,
  Button,
  CopyButton,
  Group,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";

/**
 * Read-only URL field with a copy-to-clipboard button and an optional
 * "Preview" button that opens the URL in a new tab.
 */
const CopyableUrl = ({ url, withPreview = true, previewLabel = "Preview" }) => (
  <Group gap="xs">
    <TextInput
      value={url}
      readOnly
      style={{ flex: 1 }}
      styles={{
        input: {
          fontSize: "13px",
        },
      }}
    />
    <CopyButton value={url} timeout={2000}>
      {({ copied, copy }) => (
        <Tooltip label={copied ? "Copied" : "Copy URL"} withArrow>
          <ActionIcon
            color={copied ? "green" : "blue"}
            variant="light"
            onClick={copy}
            size="lg"
          >
            {copied ? <IconCheck size={18} /> : <IconCopy size={18} />}
          </ActionIcon>
        </Tooltip>
      )}
    </CopyButton>
    {withPreview && (
      <Button
        component="a"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        variant="light"
        size="sm"
      >
        {previewLabel}
      </Button>
    )}
  </Group>
);

export default CopyableUrl;
